/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplyClaimBalanceSurchargeRequest
 */
export interface ApplyClaimBalanceSurchargeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApplyClaimBalanceSurchargeRequest
     */
    claimIds: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ApplyClaimBalanceSurchargeRequest
     */
    percentage: number;
    /**
     * 
     * @type {Date}
     * @memberof ApplyClaimBalanceSurchargeRequest
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof ApplyClaimBalanceSurchargeRequest
     */
    entryType: string | null;
}

/**
 * Check if a given object implements the ApplyClaimBalanceSurchargeRequest interface.
 */
export function instanceOfApplyClaimBalanceSurchargeRequest(value: object): value is ApplyClaimBalanceSurchargeRequest {
    if (!('claimIds' in value) || value['claimIds'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('entryType' in value) || value['entryType'] === undefined) return false;
    return true;
}

export function ApplyClaimBalanceSurchargeRequestFromJSON(json: any): ApplyClaimBalanceSurchargeRequest {
    return ApplyClaimBalanceSurchargeRequestFromJSONTyped(json, false);
}

export function ApplyClaimBalanceSurchargeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyClaimBalanceSurchargeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'claimIds': json['claimIds'],
        'percentage': json['percentage'],
        'date': (new Date(json['date'])),
        'entryType': json['entryType'],
    };
}

export function ApplyClaimBalanceSurchargeRequestToJSON(json: any): ApplyClaimBalanceSurchargeRequest {
    return ApplyClaimBalanceSurchargeRequestToJSONTyped(json, false);
}

export function ApplyClaimBalanceSurchargeRequestToJSONTyped(value?: ApplyClaimBalanceSurchargeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimIds': value['claimIds'],
        'percentage': value['percentage'],
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'entryType': value['entryType'],
    };
}

